











export default {
  name: 'PencilIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
